import { render, staticRenderFns } from "./MyCoursesTiles.vue?vue&type=template&id=7b711b3e&scoped=true&"
import script from "./MyCoursesTiles.vue?vue&type=script&lang=js&"
export * from "./MyCoursesTiles.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesTiles.vue?vue&type=style&index=0&id=7b711b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b711b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b711b3e')) {
      api.createRecord('7b711b3e', component.options)
    } else {
      api.reload('7b711b3e', component.options)
    }
    module.hot.accept("./MyCoursesTiles.vue?vue&type=template&id=7b711b3e&scoped=true&", function () {
      api.rerender('7b711b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesTiles.vue"
export default component.exports